import React, { useState, useEffect } from "react";
import ModalComponent from "../../Components/Modal/Modal";
import { useToggle } from "../../Hook";
import { EcecDegree, handleLogErrorToSlack } from "../../Helper";
import axios from "axios";
import { notify } from "react-notify-toast";
import uuid from "uuid/v4";
import "./Resume.css";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from "react-redux";
import {
  updateQualification,
} from "../../redux/homePage/homePage.actions";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import FormField from "../../Components/FormField/FormField";
import FormDropdown from "../../Components/FormField/FormDropdown";
import FormDatePicker from "../../Components/FormField/FormDatePicker";
import FormMultiSelect from "../../Components/FormField/FormMultiSelect";
import HoverIcon from "../../Components/FormField/HoverIcon-nova";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { API } from "../../API";
import { Fragment } from "react";


function EcecQualificationModal(props) {
  const {
    updateQualification,
  } = props;

  const [isCreate, toggleCreate] = useToggle(props.isCreate);
  const [startDate, setStartDate] = useState(
    props.content.start_date
      ? Date.parse(
          `${props.content.start_date.substring(
            0,
            2
          )}/01/${props.content.start_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [graduationDate, setGraduationDate] = useState(
    props.content.graduation_date && props.content.graduation_date !== "Present"
      ? Date.parse(
          `${props.content.graduation_date.substring(
            0,
            2
          )}/01/${props.content.graduation_date.substring(3, 7)}`
        )
      : new Date()
  );
  const [gradQDatePickerVisible, toggleQGradDatePicker] = useToggle(
    props.content.graduation_date !== "Present"
  );

  const [course_class_delivered, setcourse_class_delivered] = useState(
    props.content.course_class_delivered || []
  );

  const [qualification_fileName, setQualification_fileName] = useState(null);

  const qualification = isCreate
    ? null
    : props.user.qualifications.filter((q) => q._id === props.qualificationID);

  let [link, setLink] = useState(
    props.content ? props.content.qualification_url : ""
  );
  let [fName, setFName] = useState(
    props.content ? props.content.certificate_filename : ""
  );
  let [transcript_link, settranscript_Link] = useState(
    props.content ? props.content.transcript_url : ""
  );
  let [transcript_fName, settranscript_FName] = useState(
    props.content ? props.content.transcript_filename : ""
  );
  let [enrolment_link, setenrolment_Link] = useState(
    props.content ? props.content.enrolment_url : ""
  );
  let [enrolment_fName, setenrolment_FName] = useState(
    props.content ? props.content.enrolment_filename : ""
  );

  let [referrer_organisations, setReferrer_organisations] = useState(
    getRef_Organisations()
  );

  const [qualifications, setQualifications] = useState([])
  const [isSubmit, setIsSubmit] = useState(false)

  function getRef_Organisations() {
    let user = Object.assign({}, props.user);
    let organisation = new Set();
    if (user.professional_experience && user.professional_experience.length > 0)
      user.professional_experience.forEach((pe) => {
        organisation.add(pe.organisation);
      });
    return Array.from(organisation);
  }

  const deleteCertificate = (e) => {
    setLink(null);
    setFName(null);
  };

  const deleteTranscript = (e) => {
    settranscript_Link(null);
    settranscript_FName(null);
  };

  const deleteEnrolment = (e) => {
    setenrolment_Link(null);
    setenrolment_FName(null);
  };
  const handleClose = () => {
    if (!isSubmit) {
      props.showPopup(false);
    }
    props.resetFile()
    props.toggleLoading(false)
  };

  const prepareValue = (id, linkFile) => {
    const institution_name = document
      .querySelector("#institution")
      .value.trim();

    const degree = document.querySelector("#degree").value;
    const start_date = document.querySelector("#start_date").value;
    const qualification_url = linkFile;
    const transcript_url = transcript_link;
    const enrolment_url = enrolment_link;
    const certificate_filename = fName;
    const transcript_filename = transcript_fName;
    const enrolment_filename = enrolment_fName;
    const institution_website = document.querySelector("#institution-website")
      .value;
    const verification_status = false;
    const graduation_date = document.querySelector("#current_date").checked
      ? "Present"
      : document.querySelector("#graduation_date").value;
    const institution_location = document
      .querySelector("#institution-location")
      .value.trim();
    const newQualification = {
      institution_name: institution_name,
      degree: degree,
      // major: major,
      qualification_url: qualification_url,
      qualification_status: false,
      transcript_url: transcript_url,
      enrolment_url: enrolment_url,
      transcript_status: false,
      certificate_filename: certificate_filename,
      transcript_filename: transcript_filename,
      enrolment_filename: enrolment_filename,
      institution_website: institution_website,
      institution_location: institution_location,
      // award_name: award_name,
      start_date: start_date,
      graduation_date: graduation_date,
      verification_status: verification_status,
      _id: id,
      // description: description
    };
    return newQualification;
  };

  const sendEmailNotification = (tpenIndx, emailType) => {
    API.sendTeacherProfileProgressEmail({
      _id: props.user._id,
      to: props.user.email,
      first_name: props.user.first_name,
      etype: emailType,
    }).then((result) => {
        console.log("result:", result);
      })
      .catch((err) => {
        console.log("err:", err);
      });
  };

  const handleSave = async (event) => {
    let updateType = "";
    event.preventDefault();
    setIsSubmit(true)
    let linkUploaded = ""
    try {
      linkUploaded = props.isUploadDrive ? await handleUploadGoogleDriveFile() : await handleUploadFile()
    } catch (error) {
      console.log('error', error)
    }
    if (!linkUploaded) {
      props.resetFile()
      props.toggleLoading(false)
      setIsSubmit(false)
      props.showPopup(false);
      return
    }

    const id = uuid();
    // ======= Prepare values =======
    const newQualification = prepareValue(id, linkUploaded);
    const content_id = props.content._id;
    const valid = checkFiles(newQualification);
    if (valid) {
      // ======= Close popup =======
      props.showPopup(false);

      // Email notification
      sendEmailNotification(6, "QUAL_CONF");

      // ======= Update user  =======
      if (props.content !== "" && content_id) {
        updateType = "EDIT";
        updateQualification({ newQualification, updateType, content_id });
      } else {
        updateType = "ADD";
        updateQualification({ newQualification, updateType });
      }
    }

    props.resetFile()
    props.toggleLoading(false)
    setIsSubmit(false)
  };

  const checkFiles = (newQualification, isVet) => {
    let isvalid = true;
    if (document.getElementById("qualification-date-file").getAttribute('hidden')) {
      return isvalid
    }
    if (!document.querySelector("#current_date").checked) {
      if (
        newQualification.certificate_filename === "" ||
        newQualification.certificate_filename === null
      ) {
        notify.show("Please upload your certificate");
        isvalid = false;
      } else if (
        !isVet &&
        (newQualification.transcript_filename === "" ||
          newQualification.transcript_filename === null)
      ) {
        notify.show("Please upload your transcript");
        isvalid = false;
      } else {
        isvalid = true;
      }
    } else if (
      newQualification.enrolment_filename === "" ||
      newQualification.enrolment_filename === null
    ) {
      notify.show("Please upload your statement of Enrolment");
      isvalid = false;
    }
    return isvalid;
  };

  //When select a degree in qualification form, change happen
  const changeforselectELTdegree = (e) => {
    
  };

  const uploadDocument = (id) => {
    document.getElementById(id).click();
  };

  const uploadFileToServer = (e, fileNamePrefix, uploadingCompleted) => {
    const file = e.target.files[0];
    const filesize = e.target.files[0].size >> 10;

    if (filesize > 600) {
      notify.show(
        "File size exceeds the maximum 600KB. Please compress your document using https://smallpdf.com/compress-pdf or similar and upload again."
      );
    } else if (file) {
      const [preFileName, fileType] = e.target.files[0].name.split(".");
      const fileName = preFileName
        .replace(/[^\w.]/gi, "")

      API.uploadFileToS3({
        fileName: `${fileNamePrefix}${fileName}`,
        fileType: fileType,
        _id: props.user._id,
      })
        .then((res) => {
          const returnData = res.data.data.returnData;
          const signedRequest = returnData.signedRequest;
          const url = returnData.url;
          const options = {
            headers: {
              "Content-Type": fileType,
            },
          };
          axios
            .put(signedRequest, file, options)
            .then((res2) => {
              const newUser = Object.assign({}, props.user);
              const cut_length = "https://platform-backend-files.s3.amazonaws.com/"
                .length;
              const suffix = url.substring(cut_length, url.length);
              const prefix =
                // "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path=";
                "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path="; 
              const new_url = prefix + suffix;
              const urlSplittedArray = url.split(
                `${props.user._id}/${fileNamePrefix}`
              );

              uploadingCompleted(newUser, new_url, fileName, urlSplittedArray);
            })
            .catch((error1) => {
              handleLogErrorToSlack(error1, true)
              console.log(error1);
            });
        })
        .catch((err) => {
          alert(JSON.stringify(err));
        });
    } else {
      console.log("Upload Error");
    }
  };

  const handleUploadGoogleDriveFile = async () => {
    try {
      props.toggleLoading(true)

      const response = await API.uploadGoogleDriveFileToS3(props.fileFromDrive);
      const url = response?.data?.data
      const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
      const suffix = url.substring(cut_length, url.length);
      const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
      const new_url = prefix + suffix;

      props.toggleLoading(false)
      setLink(new_url);
      return new_url
    } catch (error) {
      notify.show("Error when upload file. Please try again later")
      console.log(`⚡️[log]: †††††† ~ error: `, error);
      handleLogErrorToSlack(error);
      props.toggleLoading(false)
    }
    return null
  };

  const handleUploadFile = async () => {
    const file = props.file
    if (file) {
      try {
        props.toggleLoading(true)

        const [preFileName, fileType] = file.name.split(".");
        const fileName = preFileName
          .replace(/[^\w.]/gi, "")
          .replace(/  +/g, "");

        const formData = new FormData();
        formData.append("file", file);
        formData.append("fileName", `qualification_${fileName}`)
        const response = await API.uploadCompressedFileToS3(formData)

        const url = response?.data?.data
        const cut_length = "https://platform-backend-files.s3.amazonaws.com/".length;
        const suffix = url.substring(cut_length, url.length);
        const prefix = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=";
        const new_url = prefix + suffix;

        props.toggleLoading(false)
        setLink(new_url);
        return new_url
      } catch (error) {
        props.toggleLoading(false)
        notify.show("File cannot uploaded. Please choose another file.")
        handleLogErrorToSlack(error, true);
        console.log(error);
      }
  }

  return null
}

  const updateQualificationForUser = (newUser, newUrl, fileName) => {
    newUser.qualification_url = newUrl;
    newUser.qualification_filename = fileName;
  };


  const qualificatonUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    setLink(newUrl);
    setFName(urlSplittedArray[1]);
  };

  const handleSaveQualificationFile = (e) => {
    uploadFileToServer(e, "qualification", qualificatonUploadingCompleted);
  };

  const transcriptUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    updateQualificationForUser(newUser, newUrl, fileName);

    setQualification_fileName(fileName);
    settranscript_Link(newUrl);
    settranscript_FName(urlSplittedArray[1]);
  };

  const handleSaveTranscriptFile = (e) => {
    uploadFileToServer(
      e,
      "qualification/transcript",
      transcriptUploadingCompleted
    );
  };

  const enrolmentUploadingCompleted = (
    newUser,
    newUrl,
    fileName,
    urlSplittedArray
  ) => {
    newUser.enrolment_url = newUrl;
    newUser.enrolment_filename = fileName;

    setQualification_fileName(fileName);
    setenrolment_Link(newUrl);
    setenrolment_FName(urlSplittedArray[1]);
  };

  const handleSaveEnrolmentFile = (e) => {
    uploadFileToServer(
      e,
      "qualification/enrolment",
      enrolmentUploadingCompleted
    );
  };

  const buildCommonQualificationContent = () => {
    const ececAwardTypes = [
      <option value={EcecDegree.CERT}>{EcecDegree.CERT}</option>,
      <option value={EcecDegree.DIPLOMA}>{EcecDegree.DIPLOMA}</option>,
      <option value={EcecDegree.BACHELOR}>{EcecDegree.BACHELOR}</option>,
      <option value={EcecDegree.GRADUATE_DIPLOMA}>{EcecDegree.GRADUATE_DIPLOMA}</option>,
    ]

    return (
      <Fragment>
        <div className="row">
          <div className="col-md-6">
            <FormDropdown
              label="Award Type"
              name="degree"
              id="degree"
              required
              defaultValue={props.content ? props.content.degree : ""}
              onChange={changeforselectELTdegree}
              noMargin
            >
              <option value="" hidden>
                Please Select
              </option>
              {ececAwardTypes}
            </FormDropdown>

            <div id='institution-info'>
              <FormField
                label="Institution Name"
                name="institution"
                id="institution"
                // placeholder="University of Sydney"
                required
                defaultValue={
                  props.content
                    ? props.content.institution_name
                    : qualification
                    ? qualification[0].institution_name
                    : ""
                }
                noMargin
              />

              <FormField
                label="Institution Website"
                name="institution-website"
                id="institution-website"
                // placeholder="sydney.edu.au"
                required
                defaultValue={
                  props.content ? props.content.institution_website : ""
                }
                noMargin
              />

              <FormField
                label="Institution City/Town"
                name="institution-location"
                id="institution-location"
                pattern="^[A-Za-z\s]+$"
                title="Please enter a valid City/Town"
                placeholder="Sydney"
                required
                defaultValue={
                  props.content ? props.content.institution_location : ""
                }
                noMargin
              />
            </div>
          </div>

          <div className="col-md-6" id='qualification-date-file'>
            <FormDatePicker
              label="Start Date"
              id="start_date"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              selectsStart
              startDate={startDate}
              endDate={graduationDate}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              value={startDate}
              placeholderText={new Date()}
              isClearable
              maxWidth
              noMargin
              required
            />
            <CheckableButton
              checkbox
              id="current_date"
              name="current_date"
              defaultChecked={
                props.content
                  ? props.content.graduation_date === "Present"
                  : false
              }
              onChange={toggleQGradDatePicker}
              noBorder
            >
              Currently Enrolled
            </CheckableButton>

            <div id="end_date_block" hidden={!gradQDatePickerVisible}>
              <FormDatePicker
                label="Graduation Date"
                id="graduation_date"
                selected={graduationDate}
                onChange={(date) => setGraduationDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={graduationDate}
                dateFormat="MM/yyyy"
                showMonthYearPicker
                value={graduationDate}
                minDate={startDate}
                placeholderText={new Date()}
                isClearable
                maxWidth
                required={gradQDatePickerVisible}
              />
            </div>
            {/* document upload */}

            <div className="form-group" hidden={!gradQDatePickerVisible}>
              <FormField
                label={"Upload Certificate"}
                id="certificate"
                placeholder={
                  fName
                    ? fName
                    : "Upload jpeg jpg or pdf"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () => uploadDocument("upload_qualification"),
                  id: "Select_Button",
                  label: fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: fName,
                }}
                footer={
                  fName && link ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${link}`}
                        target="_blank"
                      >
                        <p className="uploaded-file-name mt-1 ml-1">{fName}</p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteCertificate}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_qualification"
                name="upload_qualification"
                onChange={handleSaveQualificationFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <div className="form-group" hidden={gradQDatePickerVisible}>
              <FormField
                label="Upload Statement of Enrolment"
                id="certificate"
                placeholder={
                  enrolment_fName
                    ? enrolment_fName
                    : "No file chosen (.jpg and .pdf files supported)"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () => uploadDocument("upload_enrolment"),
                  id: "Select_Button",
                  label: enrolment_fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: enrolment_fName,
                }}
                footer={
                  enrolment_fName ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${enrolment_link}`}
                        target="_blank"
                      >
                        <p className="uploaded-file-name mt-1 ml-1">
                          {enrolment_fName}
                        </p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteEnrolment}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_enrolment"
                name="upload_enrolment"
                onChange={handleSaveEnrolmentFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <div className="form-group">
              <FormField
                label="Upload Academic Transcript/Statement of Results"
                id="certificate"
                placeholder={
                  transcript_fName
                    ? transcript_fName
                    : "Upload jpeg jpg or pdf"
                }
                disabled
                header={
                  <>
                    <HoverIcon
                      icon="lock"
                      color="grey"
                      text="Your documents will be encrypted and stored securely"
                    />
                    <HoverIcon
                      icon="info circle"
                      color="grey"
                      text="Please upload a file less than 600KB."
                    />
                  </>
                }
                sideButton={{
                  onClick: () =>
                    uploadDocument("upload_qualificationTranscript"),
                  id: "Select_Button_1",
                  label: transcript_fName ? "Uploaded" : "Select",
                  small: true,
                  disabled: transcript_fName,
                }}
                footer={
                  transcript_fName ? (
                    <div className="text-left d-flex">
                      <a
                        href={`/NavigateToFileViewer?fileurl=${transcript_link}`}
                      >
                        <p className="uploaded-file-name mt-1 ml-1">
                          {transcript_fName}
                        </p>
                      </a>
                      <i
                        className="mdi mdi-delete-circle d-flex mt-1 ml-1 uploaded-file-delete-icon"
                        onClick={deleteTranscript}
                      ></i>
                    </div>
                  ) : (
                    ""
                  )
                }
              />
              <input
                type="file"
                id="upload_qualificationTranscript"
                name="upload_qualificationTranscript"
                onChange={handleSaveTranscriptFile}
                style={{ display: "none" }}
                accept=".jpg, .pdf"
              />
            </div>

            <p className="small">
              To ensure successful verification, please upload clearly scanned
              or photographed documents.
            </p>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-6 mb-2 mb-md-0">
            <CancelButton type="back" value="Back" onClick={handleClose} disabled={isSubmit}>
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton type="submit" disabled={isSubmit}>Submit</ConfirmButton>
          </div>
        </div>
      </Fragment>
    );
  };

  const qualificationForm = () => {
    return (
      <ModalComponent
        show={true}
        className="qualification-form-modal"
        header="ECEC Qualification"
        onClose={handleClose}
      >
        <div className="model-main-content">
          <form onSubmit={handleSave}>{buildCommonQualificationContent()}</form>
        </div>
      </ModalComponent>
    );
  };

  useEffect(() => {
    // Change the date picker style
    const date_picker = document.querySelectorAll(".react-datepicker-wrapper");
    if (date_picker.length !== 0) {
      for (let i = 0; i < date_picker.length; i++) {
        date_picker[i].style.display = "block";
      }
    }
  });

  useEffect(() => {
    API.getQualificationList()
      .then((result) => {
        setQualifications(result?.data?.data)
      })
      .catch((err) => {
        console.log(`⚡️[log]: †††††† ~ err: `, err);
      })
  }, [])

  return (
    <>
      {props.formType === "qualification" && qualificationForm()}
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  updateQualification: (user) => dispatch(updateQualification(user)),
});

export default connect(null, mapDispatchToProps)(EcecQualificationModal);
